<template>
  <v-container fill-height>
    <v-layout row justify-center align-center>
      <v-flex xs12 md6>
        <v-layout column>
          <v-flex sm12>
            <v-card class="card">
              <v-card-title primary-title>
                <h1 class="headline mb-0">
                  <v-icon left large> fa fa-lock </v-icon> Alterar Senha
                </h1>
              </v-card-title>
              <v-card-text>
                <v-form>
                  <v-container class="pt-0">
                    <v-layout>
                      <v-flex xs12 md6>
                        <v-text-field
                          v-model="usuario.senha"
                          name="login"
                          label="Sua senha atual"
                          type="password"
                          :error-messages="senhaErrors"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field
                          v-model="confirmarSenha"
                          name="password"
                          label="Confirmar senha atual"
                          type="password"
                          :error-messages="confirmarSenhaErrors"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-divider></v-divider>
                    <v-text-field
                      v-model="usuario.novaSenha"
                      name="password"
                      label="Sua nova senha"
                      type="password"
                      :error-messages="novaSenhaErrors"
                    ></v-text-field>
                    <v-btn
                      type="submit"
                      @click.prevent="salvar"
                      :disabled="$v.$anyError"
                      color="primary"
                      block
                    >
                      Confirmar
                    </v-btn>
                  </v-container>
                </v-form>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import { required, sameAs } from "vuelidate/lib/validators";
export default {
  name: "AlterarSenha",
  data() {
    return {
      usuario: {
        senha: "",
        novaSenha: "",
      },
      idusuario: this.$store.getters.userId,
      confirmarSenha: "",
    };
  },
  computed: {
    senhaErrors() {
      const errors = [];
      if (!this.$v.usuario.senha.$dirty) return errors;
      !this.$v.usuario.senha.required && errors.push("Campo obrigatorio.");
      return errors;
    },
    confirmarSenhaErrors() {
      const errors = [];
      if (!this.$v.confirmarSenha.$dirty) return errors;
      !this.$v.confirmarSenha.sameAsSenha &&
        errors.push("As senhas devem ser iguais");
      return errors;
    },
    novaSenhaErrors() {
      const errors = [];
      if (!this.$v.usuario.novaSenha.$dirty) return errors;
      !this.$v.usuario.novaSenha.required && errors.push("Campo obrigatorio.");
      return errors;
    },
  },
  validations: {
    usuario: {
      senha: { required },
      novaSenha: { required },
    },
    confirmarSenha: {
      sameAsSenha: sameAs(function () {
        return this.usuario.senha;
      }),
    },
  },
  methods: {
    salvar() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        axios
          .put(`/usuario/setSenha/${this.idusuario}`, this.usuario)
          .then(() => {
            this.$router.push("/pontosPesquisa");
          });
      }
    },
  },
};
</script>

<style scoped>
.v-layout {
  top: -70%;
}
</style>
